var exports = {
  "ec": "SelectionsTab.module__descriptionSmall___RlJMcm",
  "Uz": "SelectionsTab.module__gridDouble___RlJMcm",
  "hK": "SelectionsTab.module__gridSingle___RlJMcm",
  "Wh": "SelectionsTab.module__contentList___RlJMcm",
  "Ib": "SelectionsTab.module__sliderRow___RlJMcm",
  "xJ": "SelectionsTab.module__sliderContainer___RlJMcm",
  "rv": "SelectionsTab.module__sliderValue___RlJMcm",
  "RE": "SelectionsTab.module__sliderValueDisabled___RlJMcm",
};

module.exports = exports;
